function monthKey(year: number, month: number) {
    return `${year}-${month}`;
}

function mondayGridStartUtc(year: number, month: number): Date {
    const first = new Date(Date.UTC(year, month - 1, 1));
    const dow = first.getUTCDay();
    const offset = dow === 0 ? -6 : 1 - dow;
    const start = new Date(first);
    start.setUTCDate(first.getUTCDate() + offset);
    return start;
}

/* ═══════════════════════════════════════════════════════════════════════════
   Moses — Webull US-STOCKS (Feb–Apr 2026 screenshots)
   ═══════════════════════════════════════════════════════════════════════════ */

export const MOSES_MONTH_VIEW_TOTAL_USD: Record<string, number> = {
    '2026-2': 10050.0,
    '2026-3': 17200.0,
    '2026-4': 23100.0,
};

export const MOSES_SCREENSHOT_CUMULATIVE_PNL =
    MOSES_MONTH_VIEW_TOTAL_USD['2026-2'] +
    MOSES_MONTH_VIEW_TOTAL_USD['2026-3'] +
    MOSES_MONTH_VIEW_TOTAL_USD['2026-4'];

export const MOSES_MONTH_STATS: Record<
    string,
    { wins: number; losses: number; winRate: number; totalTrades: number }
> = {
    '2026-2': { wins: 16, losses: 4, winRate: 80.0, totalTrades: 20 },
    '2026-3': { wins: 17, losses: 5, winRate: 77.3, totalTrades: 22 },
    '2026-4': { wins: 19, losses: 3, winRate: 86.4, totalTrades: 22 },
};

export const MOSES_GRID_VALUES: Record<string, readonly (number | null)[]> = {
    '2026-2': [
        null, null, null, null, null, null, null,
        1059.26, 516.61, -1072.02, 475.36, 801.25, null, null,
        -305.26, 1198.43, 412.88, 817.06, 664.91, null, null,
        715.81, 831.99, 987.91, -198.9, 679.85, null, null,
        867.74, -194.28, 592.85, 273.33, 925.22, null, null,
        null, null, null, null, null, null, null,
    ],
    '2026-3': [
        null, null, null, null, null, null, null,
        1000.12, 519.34, 2114.79, -507.8, -835.37, null, null,
        1014.9, 782.0, 1820.17, 1743.2, -547.53, null, null,
        1027.61, 1955.94, 1596.07, 443.26, -837.12, null, null,
        926.67, 1344.9, 963.07, 898.02, -200.9, null, null,
        1082.78, 895.88, null, null, null, null, null,
    ],
    '2026-4': [
        null, null, 655.61, 2267.76, 793.91, null, null,
        -816.69, 997.89, 1754.62, 792.07, 530.85, null, null,
        696.01, 510.94, 741.71, 1592.23, 543.0, null, null,
        2639.23, 2139.55, -456.46, 2471.24, 919.94, null, null,
        983.1, -210.08, 782.43, 2771.14, null, null, null,
        null, null, null, null, null, null, null,
    ],
} as const;

/* ═══════════════════════════════════════════════════════════════════════════
   Michel / Micheal / Michael — Webull (Feb–Apr 2026)
   ═══════════════════════════════════════════════════════════════════════════ */

export const MICHEL_MONTH_VIEW_TOTAL_USD: Record<string, number> = {
    '2026-2': 6050.0,
    '2026-3': 5020.0,
    '2026-4': 9600.0,
};

export const MICHEL_SCREENSHOT_CUMULATIVE_PNL =
    MICHEL_MONTH_VIEW_TOTAL_USD['2026-2'] +
    MICHEL_MONTH_VIEW_TOTAL_USD['2026-3'] +
    MICHEL_MONTH_VIEW_TOTAL_USD['2026-4'];

export const MICHEL_MONTH_STATS: Record<
    string,
    { wins: number; losses: number; winRate: number; totalTrades: number }
> = {
    '2026-2': { wins: 15, losses: 5, winRate: 75.0, totalTrades: 20 },
    '2026-3': { wins: 18, losses: 4, winRate: 81.8, totalTrades: 22 },
    '2026-4': { wins: 22, losses: 0, winRate: 100.0, totalTrades: 22 },
};

export const MICHEL_GRID_VALUES: Record<string, readonly (number | null)[]> = {
    '2026-2': [
        null, null, null, null, null, null, null,
        1164.99, -420, 392.16, -1049.92, 584, null, null,
        599, 569, 584, 599, -380, null, null,
        569, 584, 599, -350, 569, null, null,
        584, -999.76, 599, 569, 684.53, null, null,
        null, null, null, null, null, null, null,
    ],
    '2026-3': [
        null, null, null, null, null, null, null,
        426.02, 378.52, 378.52, 466.73, 632.1, null, null,
        378.52, -545.45, 378.52, 378.52, 378.52, null, null,
        378.52, 378.52, 378.52, 378.52, 378.52, null, null,
        -710.78, -662.3, 378.52, 378.52, 378.52, null, null,
        -470.04, 584.44, null, null, null, null, null,
    ],
    '2026-4': [
        null, null, 606, 391.26, 391.26, null, null,
        391.25, 391.25, 391.25, 391.25, 391.25, null, null,
        391.25, 391.25, 391.25, 391.25, 391.25, null, null,
        391.25, 391.25, 391.25, 887.26, 391.25, null, null,
        391.25, 391.25, 391.25, 672.97, null, null, null,
        null, null, null, null, null, null, null,
    ],
} as const;

/* ═══════════════════════════════════════════════════════════════════════════
   Daniel / David — Webull (Feb–Apr 2026; same View Stats demo profile)
   ═══════════════════════════════════════════════════════════════════════════ */

export const DANIEL_MONTH_VIEW_TOTAL_USD: Record<string, number> = {
    '2026-2': 7100.0,
    '2026-3': 8050.0,
    '2026-4': 7050.0,
};

export const DANIEL_SCREENSHOT_CUMULATIVE_PNL =
    DANIEL_MONTH_VIEW_TOTAL_USD['2026-2'] +
    DANIEL_MONTH_VIEW_TOTAL_USD['2026-3'] +
    DANIEL_MONTH_VIEW_TOTAL_USD['2026-4'];

export const DANIEL_MONTH_STATS: Record<
    string,
    { wins: number; losses: number; winRate: number; totalTrades: number }
> = {
    '2026-2': { wins: 15, losses: 5, winRate: 75.0, totalTrades: 20 },
    '2026-3': { wins: 17, losses: 5, winRate: 77.3, totalTrades: 22 },
    '2026-4': { wins: 19, losses: 3, winRate: 86.4, totalTrades: 22 },
};

export const DANIEL_GRID_VALUES: Record<string, readonly (number | null)[]> = {
    '2026-2': [
        null, null, null, null, null, null, null,
        -88.49, -136.7, 416.91, 225.25, -735.9, null, null,
        -1076.5, 715.01, 504.78, 216.72, 933.76, null, null,
        517.69, 319.51, -618.19, 737.49, 915.04, null, null,
        587.21, 1528.29, 208.83, 762.04, 1167.25, null, null,
        null, null, null, null, null, null, null,
    ],
    '2026-3': [
        null, null, null, null, null, null, null,
        -914.4, 507.29, 1135.48, 206.81, -779.45, null, null,
        -968.44, -902.16, 685.77, 1193.03, 1216.56, null, null,
        423.87, 756.73, 826.15, 1178.28, 458.99, null, null,
        1133.6, 810.15, 669.4, -913.48, 473.97, null, null,
        516.24, 335.61, null, null, null, null, null,
    ],
    '2026-4': [
        null, null, 364.99, 529.59, 168.53, null, null,
        393.78, 133.39, 304.81, 493.78, 766.5, null, null,
        186.52, 587.14, 905.99, -1092.9, 875.81, null, null,
        536.18, 415.87, 677.2, 526.35, 220.33, null, null,
        311.26, 525.97, -482.4, -298.69, null, null, null,
        null, null, null, null, null, null, null,
    ],
} as const;

/* ═══════════════════════════════════════════════════════════════════════════
   Angel — Webull (Feb–Apr 2026)
   ═══════════════════════════════════════════════════════════════════════════ */

export const ANGEL_MONTH_VIEW_TOTAL_USD: Record<string, number> = {
    '2026-2': 3820.0,
    '2026-3': 3190.0,
    '2026-4': 5490.0,
};

export const ANGEL_SCREENSHOT_CUMULATIVE_PNL =
    ANGEL_MONTH_VIEW_TOTAL_USD['2026-2'] +
    ANGEL_MONTH_VIEW_TOTAL_USD['2026-3'] +
    ANGEL_MONTH_VIEW_TOTAL_USD['2026-4'];

export const ANGEL_MONTH_STATS: Record<
    string,
    { wins: number; losses: number; winRate: number; totalTrades: number }
> = {
    '2026-2': { wins: 15, losses: 5, winRate: 75.0, totalTrades: 20 },
    '2026-3': { wins: 18, losses: 4, winRate: 81.8, totalTrades: 22 },
    '2026-4': { wins: 22, losses: 0, winRate: 100.0, totalTrades: 22 },
};

export const ANGEL_GRID_VALUES: Record<string, readonly (number | null)[]> = {
    '2026-2': [
        null, null, null, null, null, null, null,
        735.58, 523.5, 695.07, -662.92, -615.01, null, null,
        165.43, -149.37, 619.79, 98.74, -688.04, null, null,
        563.76, 497.36, 454.98, 483.81, 478.18, null, null,
        396.71, -631.25, 161.09, 260.37, 432.22, null, null,
        null, null, null, null, null, null, null,
    ],
    '2026-3': [
        null, null, null, null, null, null, null,
        270.72, 386.52, 192.7, 296.59, 383.8, null, null,
        269.48, -346.61, 65.09, 401.67, 211.2, null, null,
        150.38, 397.83, 371.61, 290.94, 151.78, null, null,
        -451.67, -420.86, 183.74, 136.22, 176.19, null, null,
        -298.69, 371.37, null, null, null, null, null,
    ],
    '2026-4': [
        null, null, 346.56, 151.95, 152.26, null, null,
        373.61, 201.76, 315.86, 269.44, 189.63, null, null,
        313.89, 206.18, 192.96, 104.55, 111.7, null, null,
        378.44, 79.51, 308.41, 507.4, 258.74, null, null,
        133.09, 92.75, 416.45, 384.86, null, null, null,
        null, null, null, null, null, null, null,
    ],
} as const;

/* ═══════════════════════════════════════════════════════════════════════════
   Ruth — Webull (Feb–Apr 2026 scripted View Stats calendar)
   ═══════════════════════════════════════════════════════════════════════════ */

export const RUTH_MONTH_VIEW_TOTAL_USD: Record<string, number> = {
    '2026-2': 21000.0,
    '2026-3': 23500.0,
    '2026-4': 27500.0,
};

export const RUTH_SCREENSHOT_CUMULATIVE_PNL =
    RUTH_MONTH_VIEW_TOTAL_USD['2026-2'] +
    RUTH_MONTH_VIEW_TOTAL_USD['2026-3'] +
    RUTH_MONTH_VIEW_TOTAL_USD['2026-4'];

export const RUTH_MONTH_STATS: Record<
    string,
    { wins: number; losses: number; winRate: number; totalTrades: number }
> = {
    '2026-2': { wins: 15, losses: 5, winRate: 75.0, totalTrades: 125 },
    '2026-3': { wins: 17, losses: 5, winRate: 77.3, totalTrades: 128 },
    '2026-4': { wins: 18, losses: 4, winRate: 81.8, totalTrades: 127 },
};

export const RUTH_GRID_VALUES: Record<string, readonly (number | null)[]> = {
    '2026-2': [
        null, null, null, null, null, null, null,
        1245.5, 612.3, -1180.0, 542.8, 912.4, null, null,
        -348.2, 1365.0, 472.1, 932.5, 758.6, null, null,
        818.4, 951.2, 1129.0, -227.5, 777.3, null, null,
        992.1, -222.0, 678.0, 312.5, 1058.0, null, null,
        null, null, null, null, null, null, null,
    ],
    '2026-3': [
        null, null, null, null, null, null, null,
        1175.0, 610.5, 2485.0, -596.0, -982.0, null, null,
        1192.0, 918.5, 2138.0, 2048.0, -643.0, null, null,
        1208.0, 2298.0, 1875.0, 521.0, -982.5, null, null,
        1088.0, 1578.0, 1130.0, 1055.0, -236.0, null, null,
        1272.0, 1052.0, null, null, null, null, null,
    ],
    '2026-4': [
        null, null, 772.0, 2670.0, 934.0, null, null,
        -962.0, 1175.0, 2065.0, 932.0, 624.0, null, null,
        820.0, 602.0, 874.0, 1875.0, 640.0, null, null,
        3105.0, 2520.0, -538.0, 2910.0, 1080.0, null, null,
        1158.0, -247.0, 920.0, 3260.0, null, null, null,
        null, null, null, null, null, null, null,
    ],
} as const;

/* ═══════════════════════════════════════════════════════════════════════════
   DarickGoldTrader — Forex XAU/USD (Apr–May 2026 screenshots / gold script)
   ═══════════════════════════════════════════════════════════════════════════ */
export const DARICK_MONTH_VIEW_TOTAL_USD: Record<string, number> = {
    '2026-4': 22960.0,
    '2026-5': 16381.0,
};

export const DARICK_SCREENSHOT_CUMULATIVE_PNL =
    DARICK_MONTH_VIEW_TOTAL_USD['2026-4'] + DARICK_MONTH_VIEW_TOTAL_USD['2026-5'];

export const DARICK_MONTH_STATS: Record<
    string,
    { wins: number; losses: number; winRate: number; totalTrades: number }
> = {
    '2026-4': { wins: 15, losses: 7, winRate: 68.2, totalTrades: 23 },
    '2026-5': { wins: 17, losses: 5, winRate: 77.3, totalTrades: 24 },
};

export const DARICK_GRID_VALUES: Record<string, readonly (number | null)[]> = {
    '2026-4': [
        null, null, 1134.15, -250, 2585.26, null, null,
        1121.67, -320, 971.76, 2769.38, -410, null, null,
        1567.49, 2375.33, -575, 8877.31, -680, null, null,
        2023.3, -890, 3769.55, -1110, 1845, null, null,
        1924, 1852, 1462, 1103, null, null, null, null, null, null, null, null, null, null,
    ],
    '2026-5': [
        null, null, null, null, null, null, null,
        1245, 1876, 932, 1563, 2341, null, null,
        1112, -261, 2174, 1909, 862, null, null,
        1257, 1634, 723, -410, 1021, null, null,
        668, -630, 932, 1018, 366, null, null, null, null, null, null, null, null, null,
    ],
} as const;

/** Per-cell trade counts*/
export const DARICK_TRADES_GRID_VALUES: Record<string, readonly (number | null)[]> = {
    '2026-4': [
        null, null, 1, 1, 1, null, null,
        1, 1, 1, 1, 1, null, null,
        1, 1, 1, 2, 1, null, null,
        1, 1, 1, 1, 1, null, null,
        1, 1, 1, 1, null, null, null, null, null, null, null, null, null, null,
    ],
    '2026-5': [
        null, null, null, null, null, null, null,
        1, 1, 1, 1, 1, null, null,
        1, 1, 2, 1, 1, null, null,
        1, 2, 1, 1, 1, null, null,
        1, 1, 1, 1, 1, 1, 1, null, null, null, null, null, null, null,
    ],
} as const;

export type ViewStatsDemoProfile = 'darick' | 'moses' | 'daniel' | 'michel' | 'angel' | 'ruth';

const GRIDS: Record<ViewStatsDemoProfile, Record<string, readonly (number | null)[]>> = {
    darick: DARICK_GRID_VALUES,
    moses: MOSES_GRID_VALUES,
    daniel: DANIEL_GRID_VALUES,
    michel: MICHEL_GRID_VALUES,
    angel: ANGEL_GRID_VALUES,
    ruth: RUTH_GRID_VALUES,
};

const TRADES_GRIDS: Partial<Record<ViewStatsDemoProfile, Record<string, readonly (number | null)[]>>> = {
    darick: DARICK_TRADES_GRID_VALUES,
};

const TOTALS: Record<ViewStatsDemoProfile, Record<string, number>> = {
    darick: DARICK_MONTH_VIEW_TOTAL_USD,
    moses: MOSES_MONTH_VIEW_TOTAL_USD,
    daniel: DANIEL_MONTH_VIEW_TOTAL_USD,
    michel: MICHEL_MONTH_VIEW_TOTAL_USD,
    angel: ANGEL_MONTH_VIEW_TOTAL_USD,
    ruth: RUTH_MONTH_VIEW_TOTAL_USD,
};

const CUMULATIVE: Record<ViewStatsDemoProfile, number> = {
    darick: DARICK_SCREENSHOT_CUMULATIVE_PNL,
    moses: MOSES_SCREENSHOT_CUMULATIVE_PNL,
    daniel: DANIEL_SCREENSHOT_CUMULATIVE_PNL,
    michel: MICHEL_SCREENSHOT_CUMULATIVE_PNL,
    angel: ANGEL_SCREENSHOT_CUMULATIVE_PNL,
    ruth: RUTH_SCREENSHOT_CUMULATIVE_PNL,
};

const MONTH_STATS: Record<
    ViewStatsDemoProfile,
    Record<string, { wins: number; losses: number; winRate: number; totalTrades: number }>
> = {
    darick: DARICK_MONTH_STATS,
    moses: MOSES_MONTH_STATS,
    daniel: DANIEL_MONTH_STATS,
    michel: MICHEL_MONTH_STATS,
    angel: ANGEL_MONTH_STATS,
    ruth: RUTH_MONTH_STATS,
};

export interface MosesCalendarCell {
    iso: string;
    dayOfMonth: number;
    utcMonth: number;
    utcYear: number;
    pnl: number | null;
    tradesCount: number | null;
}

export interface MosesLeaderboardPnlDaily {
    date: string;
    day: number;
    pnl: number;
    tradesCount: number;
}

export interface MosesLeaderboardPnlPayload {
    success: boolean;
    monthlyNetTotal: number;
    annualNetTotal: number;
    totalPnl?: number;
    dailyPerformance: MosesLeaderboardPnlDaily[];
    statistics: {
        winRate: number;
        winLossRatio: string;
        totalTrades: number;
        bestDay: number;
        worstDay: number;
        bestTrade: number;
        worstTrade: number;
    };
}

const LEADERBOARD_ROI_ANCHOR_PERCENT = 48.25;
export const LEADERBOARD_ROI_NOTIONAL_USD =
    MOSES_SCREENSHOT_CUMULATIVE_PNL / (LEADERBOARD_ROI_ANCHOR_PERCENT / 100);

export function leaderboardRoiPercentFromPnl(pnl: number): number {
    const x = Number(pnl);
    if (!Number.isFinite(x) || LEADERBOARD_ROI_NOTIONAL_USD <= 0) return 0;
    return Number(((x / LEADERBOARD_ROI_NOTIONAL_USD) * 100).toFixed(2));
}

export const MOSES_LEADERBOARD_DEMO_ROW_STATS = {
    pnl: MOSES_SCREENSHOT_CUMULATIVE_PNL,
    winRate: 82.65,
    trades: 512,
} as const;

export const MICHEL_LEADERBOARD_DEMO_ROW_STATS = {
    pnl: MICHEL_SCREENSHOT_CUMULATIVE_PNL,
    winRate: 75.0,
    trades: 516,
} as const;

export const DANIEL_LEADERBOARD_DEMO_ROW_STATS = {
    pnl: DANIEL_SCREENSHOT_CUMULATIVE_PNL,
    winRate: 75.0,
    trades: 516,
} as const;

export const ANGEL_LEADERBOARD_DEMO_ROW_STATS = {
    pnl: ANGEL_SCREENSHOT_CUMULATIVE_PNL,
    winRate: 40.32,
    trades: 186,
} as const;

export const RUTH_LEADERBOARD_DEMO_ROW_STATS = {
    pnl: RUTH_SCREENSHOT_CUMULATIVE_PNL,
    winRate: 74.5,
    trades: 380,
} as const;

export const DARICK_LEADERBOARD_DEMO_ROW_STATS = {
    pnl: DARICK_SCREENSHOT_CUMULATIVE_PNL,
    winRate: 72.7,
    trades: 47,
} as const;

export function isDarickGoldTraderName(name: string | null | undefined): boolean {
    const normalized = String(name || '')
        .trim()
        .toLowerCase()
        .replace(/[\s_-]+/g, '');
    if (!normalized) return false;
    if (normalized === 'darickgoldtrader') return true;
    return normalized.includes('darick') && normalized.includes('gold');
}

export function isMosesLeaderboardDemoName(name: string | null | undefined): boolean {
    const raw = String(name || '')
        .trim()
        .toLowerCase();
    if (!raw) return false;
    if (raw === 'moses' || raw === 'moses master') return true;
    return raw.split(/\s+/)[0] === 'moses';
}

export function isAngelLeaderboardDemoName(name: string | null | undefined): boolean {
    const raw = String(name || '')
        .trim()
        .toLowerCase();
    if (!raw) return false;
    if (raw === 'angel') return true;
    return raw.split(/\s+/)[0] === 'angel';
}

export function isRuthLeaderboardDemoName(name: string | null | undefined): boolean {
    const raw = String(name || '')
        .trim()
        .toLowerCase();
    if (!raw) return false;
    if (raw === 'ruth' || raw === 'ruth master') return true;
    return raw.split(/\s+/)[0] === 'ruth';
}

export function isMichelLeaderboardDemoName(name: string | null | undefined): boolean {
    const raw = String(name || '')
        .trim()
        .toLowerCase();
    if (!raw) return false;
    if (raw === 'micheal' || raw === 'michel' || raw === 'michael' || raw === 'michel master') return true;
    const first = raw.split(/\s+/)[0];
    return first === 'micheal' || first === 'michel' || first === 'michael';
}

export function isDanielLeaderboardDemoName(name: string | null | undefined): boolean {
    const raw = String(name || '')
        .trim()
        .toLowerCase();
    if (!raw) return false;
    if (raw === 'daniel' || raw === 'daniel master' || raw === 'daniel masterka') {
        return true;
    }
    const first = raw.split(/\s+/)[0];
    return first === 'daniel';
}

export function isDavidLeaderboardDemoName(name: string | null | undefined): boolean {
    const raw = String(name || '')
        .trim()
        .toLowerCase();
    if (!raw) return false;
    if (raw === 'david' || raw === 'david master') return true;
    return raw.split(/\s+/)[0] === 'david';
}

/** @deprecated David is shown on leaderboard*/
export function isDavidTraderHiddenFromLeaderboard(name: string | null | undefined): boolean {
    return false;
}

export function resolveViewStatsDemoProfile(name: string | null | undefined): ViewStatsDemoProfile | null {
    if (isDarickGoldTraderName(name)) return 'darick';
    if (isMosesLeaderboardDemoName(name)) return 'moses';
    if (isAngelLeaderboardDemoName(name)) return 'angel';
    if (isRuthLeaderboardDemoName(name)) return 'ruth';
    if (isMichelLeaderboardDemoName(name)) return 'michel';
    if (isDanielLeaderboardDemoName(name)) return 'daniel';
    if (isDavidLeaderboardDemoName(name)) return 'daniel';
    return null;
}

export function isLeaderboardViewStatsDemoName(name: string | null | undefined): boolean {
    return resolveViewStatsDemoProfile(name) !== null;
}

function getLeaderboardDemoGrid(profile: ViewStatsDemoProfile, viewYear: number, viewMonth: number) {
    const key = monthKey(viewYear, viewMonth);
    return GRIDS[profile][key];
}

function getLeaderboardDemoTradesGrid(profile: ViewStatsDemoProfile, viewYear: number, viewMonth: number) {
    const key = monthKey(viewYear, viewMonth);
    return TRADES_GRIDS[profile]?.[key];
}

export function getLeaderboardDemoCalendarCells(
    profile: ViewStatsDemoProfile,
    viewYear: number,
    viewMonth: number,
): MosesCalendarCell[] | null {
    const values = getLeaderboardDemoGrid(profile, viewYear, viewMonth);
    const tradesValues = getLeaderboardDemoTradesGrid(profile, viewYear, viewMonth);
    if (!values || values.length !== 42) return null;

    const start = mondayGridStartUtc(viewYear, viewMonth);
    return values.map((pnl, i) => {
        const d = new Date(start);
        d.setUTCDate(start.getUTCDate() + i);
        const iso = d.toISOString().slice(0, 10);
        return {
            iso,
            dayOfMonth: d.getUTCDate(),
            utcMonth: d.getUTCMonth() + 1,
            utcYear: d.getUTCFullYear(),
            pnl,
            tradesCount: tradesValues?.[i] ?? null,
        };
    });
}

export function hasLeaderboardDemoMonth(profile: ViewStatsDemoProfile, year: number, month: number): boolean {
    return Boolean(getLeaderboardDemoGrid(profile, year, month));
}

export function buildLeaderboardDemoPnlPayload(
    profile: ViewStatsDemoProfile,
    year: number,
    month: number,
): MosesLeaderboardPnlPayload | null {
    const key = monthKey(year, month);
    const totals = TOTALS[profile][key];
    const cells = getLeaderboardDemoCalendarCells(profile, year, month);
    if (totals == null || !cells) return null;

    const inMonthPnls = cells
        .filter((c) => c.utcMonth === month && c.utcYear === year && c.pnl !== null)
        .map((c) => c.pnl as number);
    const bestDay = inMonthPnls.length ? Math.max(...inMonthPnls) : 0;
    const worstDay = inMonthPnls.length ? Math.min(...inMonthPnls) : 0;

    const dailyPerformance: MosesLeaderboardPnlDaily[] = cells
        .filter((c) => c.utcMonth === month && c.utcYear === year && c.pnl !== null)
        .map((c) => {
            const pnl = c.pnl as number;
            const tradesCount =
                c.tradesCount != null
                    ? c.tradesCount
                    : Math.max(1, Math.min(5, Math.round(Math.abs(pnl) / 400) + 1));
            return {
                date: `${c.iso}T00:00:00.000Z`,
                day: c.dayOfMonth,
                pnl,
                tradesCount,
            };
        })
        .sort((a, b) => a.day - b.day);

    const wins = dailyPerformance.filter((d) => d.pnl > 0).length;
    const losses = dailyPerformance.filter((d) => d.pnl < 0).length;
    const denom = wins + losses;
    const winRate = denom > 0 ? (wins / denom) * 100 : 0;
    const monthStatOverride = MONTH_STATS[profile][key];
    const totalTrades = monthStatOverride
        ? monthStatOverride.totalTrades
        : dailyPerformance.reduce((s, d) => s + d.tradesCount, 0);

    return {
        success: true,
        monthlyNetTotal: totals,
        annualNetTotal: CUMULATIVE[profile],
        totalPnl: totals,
        dailyPerformance,
        statistics: {
            winRate: monthStatOverride ? monthStatOverride.winRate : Number(winRate.toFixed(1)),
            winLossRatio: monthStatOverride
                ? `${monthStatOverride.wins}W / ${monthStatOverride.losses}L`
                : `${wins}W / ${losses}L`,
            totalTrades,
            bestDay,
            worstDay,
            bestTrade: bestDay * 0.28,
            worstTrade: worstDay * 0.45,
        },
    };
}

export function hasDarickLeaderboardPnlMonth(year: number, month: number): boolean {
    return hasLeaderboardDemoMonth('darick', year, month);
}

export function buildDarickLeaderboardPnlPayload(year: number, month: number): MosesLeaderboardPnlPayload | null {
    return buildLeaderboardDemoPnlPayload('darick', year, month);
}

export function getMosesLeaderboardCalendarCells(viewYear: number, viewMonth: number): MosesCalendarCell[] | null {
    return getLeaderboardDemoCalendarCells('moses', viewYear, viewMonth);
}

export function hasMosesLeaderboardPnlMonth(year: number, month: number): boolean {
    return hasLeaderboardDemoMonth('moses', year, month);
}

export function buildMosesLeaderboardPnlPayload(year: number, month: number): MosesLeaderboardPnlPayload | null {
    return buildLeaderboardDemoPnlPayload('moses', year, month);
}

export function hasMichelLeaderboardPnlMonth(year: number, month: number): boolean {
    return hasLeaderboardDemoMonth('michel', year, month);
}

export function buildMichelLeaderboardPnlPayload(year: number, month: number): MosesLeaderboardPnlPayload | null {
    return buildLeaderboardDemoPnlPayload('michel', year, month);
}

export function hasDanielLeaderboardPnlMonth(year: number, month: number): boolean {
    return hasLeaderboardDemoMonth('daniel', year, month);
}

export function buildDanielLeaderboardPnlPayload(year: number, month: number): MosesLeaderboardPnlPayload | null {
    return buildLeaderboardDemoPnlPayload('daniel', year, month);
}

export function hasAngelLeaderboardPnlMonth(year: number, month: number): boolean {
    return hasLeaderboardDemoMonth('angel', year, month);
}

export function buildAngelLeaderboardPnlPayload(year: number, month: number): MosesLeaderboardPnlPayload | null {
    return buildLeaderboardDemoPnlPayload('angel', year, month);
}

export function hasRuthLeaderboardPnlMonth(year: number, month: number): boolean {
    return hasLeaderboardDemoMonth('ruth', year, month);
}

export function buildRuthLeaderboardPnlPayload(year: number, month: number): MosesLeaderboardPnlPayload | null {
    return buildLeaderboardDemoPnlPayload('ruth', year, month);
}